import Vue from 'vue'
import Child from './Child'
import Button from './Button'
import { HasError, AlertError, AlertSuccess } from 'vform'


import alert from './alert'
import page from './page'
import pages from './pages'
import column from './column'
import row from './row'
import svgMap from './svg-map'
import btn from './btn'
import checkbox from './checkbox'
import textbox from './textbox'
import number from './number'
import card from './card'
import formGroup from './form-group'
import forceDiagram from './force-diagram'
import inputGroup from './input-group'
import btnGroup from './btn-group'
import datepicker from './datepicker'
import dropdown from './dropdown'
import donutProgress from './donut-progress'
import listGroup from './list-group'
import listGroupItem from './list-group-item'
import Modal from './modal'
import navTabs from './nav-tabs'
import slider from './slider'
import questionnaireFooter from './questionnaire-footer'
import notificationsIcon from '~/components/notifications-icon'
// Components that are registered globaly.
[
  Child,
  Button,
  HasError,
  AlertError,
  AlertSuccess,
  alert,
  page,
  pages,
  column,
  row,
  svgMap,
  btn,
  checkbox,
  textbox,
  number,
  card,
  formGroup,
  forceDiagram,
  inputGroup,
  btnGroup,
  datepicker,
  dropdown,
  donutProgress,
  listGroup,
  listGroupItem,
  Modal,
  navTabs,
  slider,
  notificationsIcon,
  questionnaireFooter,
].forEach((Component) => {
  Vue.component(Component.name, Component)
})
